import { InsuranceProductClient } from 'clients';
import { QueryKeys } from 'enums';
import { InsuranceProduct } from 'types';
import { UseQueryBaseSearchOptions } from './query/types';
import { useQuerySearch } from './query/useQuery';

export function useSearchInsuranceProduct(props?: UseQueryBaseSearchOptions<InsuranceProduct>) {
  const { filter, queryOptions, enabled } = props || {};
  return useQuerySearch({
    queryKey: QueryKeys.InsuranceProduct,
    clientClass: InsuranceProductClient,
    enabled,
    filter,
    queryOptions: {
      // Default search query options should be passed here for example:   cacheTime: 10 * 60 * 60 * 1000,
      ...queryOptions,
    },
  });
}
